import React, { Suspense, lazy } from 'react';
import AppErrorBoundary from './components/AppErrorBoundary';

const AppRouterSimple = lazy(() => import('./AppRouterSimple'));

function App() {
  return (
    <AppErrorBoundary>
      <Suspense
        fallback={(
          <div
            style={{
              minHeight: '100vh',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: '#0b0c10',
              color: '#71717a',
              fontFamily: 'system-ui, sans-serif',
            }}
          >
            Carregando SAMPRO…
          </div>
        )}
      >
        <AppRouterSimple />
      </Suspense>
    </AppErrorBoundary>
  );
}

export default App;
